import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { RegisterDialogComponent } from 'src/app/auth/register-dialog/register-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  loginForm: FormGroup;
  session: any;

  constructor(
    private _authService: AuthService,
    private _spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.session = this._authService.loggedIn();
    this.loginForm = this.formBuilder.group({
      user: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  public onSubmit(obj: FormGroup) {
    this._spinner.show();

    if (obj.status === 'INVALID') {
      this._spinner.hide()
      return this.showAlert("Campos requeridos", "Cerrar");
    }

    this._authService.login(obj.value["user"], obj.value["password"]).subscribe(
      async response => {
        sessionStorage.setItem('session', JSON.stringify(response));
        await sessionStorage.setItem('token', response["dsSesion"]["ttsesion"]["0"]["token"])
        window.location.reload();
      }, error => {
        this._spinner.hide();
        this.showAlert("Usuario invalido", "cerrar");
      }
    );
  }

  showAlert(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
    });
  }

  openRegister(prefillUser?: string) {
    this.dialog.open(RegisterDialogComponent, {
      width: '600px',
      maxWidth: '95vw',
      disableClose: true,
      data: { prefillUser: prefillUser ?? '' },
    });
  }
}

